module.exports = __webpack_public_path__ + "img/home3.d4274546.png";